import { CommentReportExcelState, CommentReportExcelActionTypes, DOWNLOAD_COMMENT_REPORT_EXCEL_REQUEST, DOWNLOAD_COMMENT_REPORT_EXCEL_SUCCESS, DOWNLOAD_COMMENT_REPORT_EXCEL_FAILURE } from "store/reducers/types/commentReport/commentReportExcel";

const defaultState: CommentReportExcelState = {
  isLoading: false,
  errorMessage: ""
};

export default function commentReportExcel(state = defaultState, action: CommentReportExcelActionTypes): CommentReportExcelState {
  switch (action.type) {
    case DOWNLOAD_COMMENT_REPORT_EXCEL_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case DOWNLOAD_COMMENT_REPORT_EXCEL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    case DOWNLOAD_COMMENT_REPORT_EXCEL_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};